import ReferPatientDocuments from "./refer-patient-documents";

export default ReferPatientDocuments;
